export default {
  url: "https://trello-clone-0.herokuapp.com",
};
